export const titleType = {
  first: 'title-first',
  secend: 'title-secend',
};
export const descType = {
  large: 'desc-large',
};
